import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './TagPage';
import { AppState } from '../../../../types/store';
import { getOrderSubnavigation, getThisTag } from '../../../../selectors/page';

export type StateProps = Pick<Props, 'tag'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  tag: getThisTag(state),
  hasOrderSubnav: !!getOrderSubnavigation(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
